import BaseDetailsContainer from "../../baseContainers/BaseDetailsContainer";
import React from "react";
import PropTypes from 'prop-types';
import DivContainer from "../../components/DivContainer";
import moment from 'moment';
import { CustomMessages } from "../../components/CustomMessages";
import BlockUi from "../../components/waitPanel/BlockUi";
import { ConfirmDialog } from "primereact/confirmdialog";
import { t } from 'i18next';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import plLocale from '@fullcalendar/core/locales/pl';
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import Constants from "../../utils/constants";
import { OverlayPanel } from 'primereact/overlaypanel';
import SettingService from "../../services/SettingService";
import LeaveRequestService from "../../services/LeaveRequestService";
import InputTextComponent from "../../components/inputs/InputTextComponent";
import ActionButton from "../../components/ActionButton";
import { withRouter } from "react-router-dom";

const acceptedColor = '#aac35e';
const rejectedColor = '#d77777';
const submittedColor = '#e6c46f';
const defaultColor = 'grey';


class LeaveRequestViewContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new LeaveRequestService());
        this.state = {
            loading: false,
            element: undefined,
            selectedMonth: moment().startOf('month'),
            dialogVisibile: false,
            events: []
        };

        this.calendarRef = React.createRef();
        this.settingService = new SettingService();
        this.renderDetails = this.renderDetails.bind(this);
        this.eventContent = this.eventContent.bind(this);
        this.refresh = this.refresh.bind(this);
        this.getEvents = this.getEvents.bind(this);
        this.increaseSelectedMonth = this.increaseSelectedMonth.bind(this);
        this.decreaseSelectedMonth = this.decreaseSelectedMonth.bind(this);
        this.goEditUrl = this.goEditUrl.bind(this);
        this.goNewUrl = this.goNewUrl.bind(this);
    }


    componentDidMount() {
        super.componentDidMount();
        this.readMessage();
    }
    
    initBeforeSetElement() {
        this.getEvents();
    }

    getEvents() {
        const { selectedMonth } = this.state;
        let employeeId = this.props.embedded ? this.props.userId : undefined;
        this.setState({
            loading: true
        }, () => {
            this.service.leaveRequestEvents(selectedMonth, employeeId)
                .then(data => {
                    let customColorData = data.map(element =>
                        ({ ...element, backgroundColor: this.colorTemplate(element.status.enumValue) })
                    );
                    this.setState({
                        events: customColorData,
                        loading: false
                    })
                }).catch(() => {
                    this.setState({
                        loading: false
                    })
                    this.showErrorMessage(t('userReporting.eventsError'));
                })
        })
    }

    goToMonth(year, month) {
        const calendarApi = this.calendarRef.current.getApi();
        const date = new Date(year, month, 1);
        calendarApi.gotoDate(date);
        this.refresh();
    };


    refresh() {
        this.getEvents();
    }

    colorTemplate(status) {
        switch (status) {
            case "SUBMITTED": return submittedColor;
            case "ACCEPTED": return acceptedColor;
            case "REJECTED": return rejectedColor;
            default:
                return defaultColor;
        }


    }

    handleDateClick(e) {
        const paramDate = moment(e.dateStr).format(Constants.DATE_JSON_FORMAT)
        const url = `/#/day-view?day=${paramDate}`
        window.location.href = url;
        this.setState({ detailsOverlay: true })
    }

    goEditUrl(element) {
        const { editUrl, detailsUrl } = this.props;
        let goEditUrl = `${editUrl}/${element.id}`;
        let goDetailsUrl = `${detailsUrl}/${element.id}`;
        this.saveCookie("leaveRequestViewCalendar", '#/employee-leave-request-view')
        window.location.href = goDetailsUrl;
    }

    goNewUrl() {
        const { newUrl } = this.props;
        let goNewUrl = `${newUrl}`;
        this.saveCookie("leaveRequestViewCalendar", '#/employee-leave-request-view')
        window.location.href = goNewUrl;
    }

    getEventDetails(content, day) {
        const {embedded} = this.props.embedded;
        let eventColor = undefined;
    
        const events = content.map((event, index) => {
            const op = React.createRef();
            eventColor = this.colorTemplate(event.status.enumValue);
            return (
                <div style={{ position: 'relative' , width: '100%'  
                }} >
                   <div
                        style={{
                            width: '100%',
                            maxWidth: '100%',
                            backgroundColor: this.colorTemplate(event.status.enumValue),
                            color: 'black',
                            borderRadius: '5px',
                            marginTop: '1%',
                            display: 'flex',
                            cursor: embedded === true ? 'auto' : 'pointer',
                            fontSize: '14px',
                            boxShadow: 'none'
                        }}
                          onClick={(e) => {
                            if(!!!this.props.embedded){
                                op.current.toggle(e)
                            } 
                           
                        }}
                    >
                    <span style={{ margin: 'auto' }}>{`${event.absenceReason.reason}` + " "}</span>
                        
                    </div>

                    {
                            <OverlayPanel ref={op} className="lr-overlay">
                                <DivContainer colClass='row'
                                    rendered={true}
                                >
                                    <DivContainer colClass='row'>
                                        <InputTextComponent
                                            id='reason'
                                            name='reason'
                                            label={'Typ urlopu'}
                                            colClass='col-md-6'
                                            value={event.absenceReason.reason}
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={'VIEW'}
                                        />
                                        <InputTextComponent
                                            id='status'
                                            name='status'
                                            label={'Status'}
                                            colClass='col-md-6'
                                            value={event.status.label}
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={'VIEW'}
                                        />
                                        <InputTextComponent
                                            id='start'
                                            name='start'
                                            label={'Data od'}
                                            colClass='col-md-6'
                                            value={event.start}
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={'VIEW'}
                                        />
                                        <InputTextComponent
                                            id='end'
                                            name='end'
                                            label={'Data do'}
                                            colClass='col-md-6'
                                            value={event.end}
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={'VIEW'}
                                        />
                                           <InputTextComponent
                                            id='description'
                                            name='description'
                                            label={'Komentarz'}
                                            colClass='col-md-6'
                                            value={event.description}
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={'VIEW'}
                                        />
                                    
                                        <div className={'leave-request-overlay-button'}>
                                            <ActionButton
                                                label='Szczegóły'
                                                handleClick={() => this.goEditUrl(event)}
                                                rendered={event.status?.enumValue === "SUBMITTED" || event.status?.enumValue === "REJECTED"}
                                            />
                                        </div>

                                    </DivContainer>
                                </DivContainer>



                            </OverlayPanel>}
                </div>
            )
        })


        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    maxWidth: '100%',
                }}>
                <div className="row" style={{width: '100%'}}>
                        
                    <label style={{ color: "black", display: 'flex', justifyContent: 'center' , backgroundColor:eventColor, margin: 'auto'}}>
                    {events}   </label>     
                         


                </div>
            </div>
        )
    }



    eventContent(eventInfo) {
        const dateStart = moment(eventInfo.event.start).format(Constants.DATE_GET_REQUEST_FORMAT_TIME);
        const eventid= parseInt(eventInfo.event.id);
        const content = this.state.events.filter(e => e.id === eventid)
        return this.getEventDetails(content, dateStart)
    }

    renderDetails() {
        this.removeCookie("leaveRequestViewCalendar");

        return (
            <React.Fragment>
                <div className="leave-request-daygrid">
                   {/* {this.props.embedded ? <span>Podgląd wszystkich wniosków uzytkownika</span> : null}  */}
                <FullCalendar
                    initialDate={this.state.selectedMonth.toDate()}
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    locale="pl"
                    ref={this.calendarRef}
                    locales={[plLocale]}
                    events={this.state.events}
                    headerToolbar={this.props.embedded ? {
                        left:  "",
                        center: "",
                        right: ""
                    } : {
                        left:  "myCustomButton",
                        center: "",
                        right: ""
                    }}
                    eventDidMount={(arg) => {

                    }}
                    eventContent={this.eventContent}  
                    customButtons={{
                        myCustomButton: {
                            text: "Dodaj wniosek",
                            click: () => {
                                this.goNewUrl()
                            }
                        }
                    }}
                />
                </div>            
                <div>
                    <span> <i className="icon mdi mdi-circle" style={{ fontSize: '20px', marginRight: '14px', color: acceptedColor}} />Wniosek zatwierdzony</span>
                    <span> <i className="icon mdi mdi-circle" style={{ fontSize: '20px', marginRight: '14px', color: submittedColor}} />Wniosek oczekuje na zatwierdzenie</span>
                    <span> <i className="icon mdi mdi-circle" style={{ fontSize: '20px', marginRight: '14px', color: rejectedColor}} />Wniosek odrzucony</span>
                    <span> <i className="icon mdi mdi-circle" style={{ fontSize: '20px', marginRight: '14px', color: defaultColor}} />Inny</span>
                   
                </div>
            </React.Fragment>
        )
    }


    renderViewWithoutCard() {
        return <DivContainer colClass=''>
            {this.state.loading ? null : this.renderDetails()}
        </DivContainer>;
    }


    decreaseSelectedMonth() {
        const { selectedMonth } = this.state;
        let newDate = selectedMonth.subtract(1, 'month');
        this.setState(
            () => ({
                selectedMonth: newDate
            }), (e) => {
                this.goToMonth(moment(newDate).year(), moment(newDate).month())
            }
        )
    }
    increaseSelectedMonth() {
        const { selectedMonth } = this.state;
        let newDate = selectedMonth.add(1, 'month');
        this.setState(
            () => ({
                selectedMonth: newDate
            }
            ), (e) => {
                this.goToMonth(moment(newDate).year(), moment(newDate).month())
            }
        )
    }

    getFormattedMonth(date) {
        const month = moment(date ? date : new Date()).month();
        const year = moment(date ? date : new Date()).year();
        let monthFormattedStr = t(`months.${month}`);
        let formattedMonthStr = monthFormattedStr.charAt(0).toUpperCase() + monthFormattedStr.slice(1);
        return (
            <span>
                {`${year} ${formattedMonthStr}`}
            </span>
        );
    }

    renderHeaderDetails() {
        const { selectedMonth } = this.state;
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'start'
            }}>
                <i className="timelineHeaderIcon mdi mdi-chevron-left icon-large-plus " style={{ marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px' }}
                    onClick={() => this.decreaseSelectedMonth()}
                />
                <i className="timelineHeaderIcon mdi mdi-chevron-right icon-large-plus " style={{ marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px' }}
                    onClick={() => this.increaseSelectedMonth()}
                />
                <span style={{
                    fontSize: '30px',
                    paddingTop: '17px'
                }}>
                    {this.getFormattedMonth(selectedMonth)}
                </span>
            </div>
        );
    }

    renderView() {
        return (
            <DivContainer colClass='details-main'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                >
                    <ConfirmDialog
                        visible={this.state.confirmDialog?.visible}
                        onHide={() => this.setConfirmDialogVisibility(false)}
                        message={this.translate(`${this.state.confirmDialog?.message}`)}
                        header={this.translate(`${this.state.confirmDialog?.header}`)}
                        icon={`pi ${this.state.confirmDialog?.header}`}
                        accept={() => this.setConfirmDialogVisibility(false)}
                        rejectClassName='display-none'
                        acceptClassName='confirm-dialog-accept'
                    />
                    <DivContainer colClass='col-12 details-main-link-container'>
                        <DivContainer colClass='row'>
                            {this.renderHeaderDetails()}
                            <DivContainer colClass='col-12'>{this.state.loading ? null : this.renderViewWithoutCard()}</DivContainer>
                        </DivContainer>
                    </DivContainer>
                </BlockUi>
            </DivContainer>
        );
    }

}


LeaveRequestViewContainer.defaultProps = {
    lazy: true,
    renderHeader: true,
    editUrl: '/#/employee-leave-request/edit',
    newUrl: '/#/employee-leave-request/create',
    detailsUrl: '/#/employee-leave-request/details',
    embedded: false,
    userId: undefined,
};

LeaveRequestViewContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailsUrl: PropTypes.string,
    embedded: PropTypes.bool,
    userId: PropTypes.number,
};

export default withRouter(LeaveRequestViewContainer);
